<div class="row">
    <div class="facility-list-dd">            
            <ng-select class="custom" placeholder="Select Facility" name="facilitySelector" [searchable]="true"
                [clearable]="false" [(ngModel)]="facilityModel" (change)="facilityChange()" [items]="facilityDisplayList"
                bindLabel="displayName" bindValue="costCenterId" required>
            </ng-select>
    </div>
</div>